import { OrgChart } from "./OrgChart";

export const elements = {
    OrgChart
};
